import './src/global.css';
import '@dls/web/assets/fonts.css';
import React from 'react';
import MarketingPageTemplate from './src/templates/marketing-page';
import { App as Dtcp } from 'dtcp-module';
import { enableFeature, FEATURES } from './scripts/featureFlag';

export const wrapPageElement = ({ props, element }) => {
  return (
    <>
      {enableFeature(FEATURES.dtcp) && <Dtcp appName="buyflow" />}
      <MarketingPageTemplate {...props}>{element}</MarketingPageTemplate>
    </>
  );
};
